import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  CardComponent,
  Filter,
  NavigationArrow,
  PageTitleAndSubTitle,
  Search,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import experience from '../../../core-utils/messages/experienceConstants';
import {
  Download,
  patientAccessTheme,
  Settings,
} from '@HomaHealth/ui-component-library';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  EXPERICENCE_SCREEN,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
} from '../../../core-utils/routes';
import { getTagProperties } from '../../../core-utils/helper-utils/notificationHelpers';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import AcknowledgeRiskModal from '../AcknowledgeRiskModal';
import {
  formatRiskTableInsights,
  getReportName,
} from '../../../core-utils/helper-utils/riskRegisterHelper';
import { handleDownloadReport } from '../../../core-utils/helper-utils/contractReportHelper';
import { useStores } from '../../../stores';
import Snackbar from '../../atoms/Snackbar';
import BasicModal from '../../atoms/BasicModal';
import {
  cellStyles1,
  Columns as InsightsColumn,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import axios from 'axios';
import properties from '../../../core-utils/properties';

type NotificationState = {
  notifications: {
    eg_nid: string;
    notification: string;
    tag: string;
    date: string;
    analysis_type: string[];
  }[];
};

const AllInsigntsAndNotification: React.FC<{}> = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      padding: '40px 64px 24px 64px',
    },
    pageHeader: {
      display: 'flex',
      gap: '10px',
      padding: '40px 64px 24px 64px',
      alignItems: 'center',
    },
    navigationArrow: {
      rotate: '180deg',
      cursor: 'pointer',
      top: '30px',
      marginBottom: '10px',
    },
    hr: {
      width: '100%',
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      margin: '18px 0px',
    },
    buttonContainer: {
      display: 'flex',
      gap: '10px',
    },
    notificationContainer: {
      width: '90%',
      padding: '10px',
      marginTop: '10px',
    },
  });

  const mockAnalysis = [
    {
      _id: '684fd630db1996cc126835f6',
      risk_id: 'RIS013',
      eg_nid: 'denali_water solutions_1733163850381',
      title:
        'Unfavorable Compliance Provisions in Pharmacy Benefit Manager (PBM) Agreement',
      description:
        'Pharmacy Benefit Manager (PBM) Agreement contains unfavorable provisions that limit fiduciary oversight or misalign with regulatory best practices  (e.g., audit rights)',
      // contract_id: '683fdaaccec29bcad7e1eff6',
      contract_id: {
        _id: '67e4d23b86ee78884fadbe2c',
        health_care_partner_id: null,
        eg_nid: 'crane_nxt_1742408999728',
        effective_date: '04-03-2023',
        reports: [
          'Compensation Transparency Compliance Check',
          'Gag Clause Prohibition Compliance Check',
          'Commercial Evaluation',
          'Comparison with Stop Loss Agreement',
        ],
        features: ['Obligations', 'Fees', 'Provision Matrix'],
        total_files: 2,
        type: ' Base Document + 1 Amendment',
        status: 'Processing',
        merge_status: 'Merged',
        is_metadata_extracted: true,
        is_document_converted: false,
        createdAt: '2025-03-27T04:21:16.000Z',
        updatedAt: '2025-03-27T07:31:29.555Z',
        __v: 0,
      },

      source_report: 'Provision Favorability Check',
      date_identified: '2025-06-16T08:30:40.408Z',
      impact: ['Compliance'],
      risk_status: 'New',
      severity_level: 'High',
      mitigation_activity: [
        {
          _id: '684fd630db1996cc126835ea',
          activity:
            'Seek legal counsel to review Pharmacy Benefit Manager (PBM) agreement',
          act_uid: 'ACT008',
        },
        {
          _id: '684fd630db1996cc126835eb',
          activity:
            'Negotiate amendment to Pharmacy Benefit Manager (PBM) agreement with existing vendor',
          act_uid: 'ACT009',
        },
        {
          _id: '684fd630db1996cc126835ec',
          activity: 'Issue RFP to find new Pharmacy Benefit Manager (PBM)',
          act_uid: 'ACT010',
        },
      ],
      vendor_type: ['Pharmacy Benefit Manager (PBM)'],
      delay_reason: [
        'Provision alignment review deferred to annual legal audit',
        'Contracting resource temporarily reassigned',
      ],
      acceptance_reason: [
        'Operational alignment mitigates legal inconsistencies',
        'Vendor committed to informal support despite contract gaps',
      ],
      remarks:
        'https://docs.google.com/spreadsheets/d/1Aesha-qmMltkXA2xAXWCzSXPjH02exUws0bl8mh1EK8/edit?gid=243548845#gid=243548845',
      createdBy: 'roshini@homahealth.us',
      updatedBy: 'roshini@homahealth.us',
      __v: 0,
      createdAt: '2025-06-16T08:30:40.421Z',
      updatedAt: '2025-06-16T08:30:40.421Z',
      notification_content:
        'Unfavorable Compliance Provisions in Pharmacy Benefit Manager (PBM) Agreement',
      activity: ['NA'],
    },
  ];
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const employerGroupStore = useStores().employerGroupStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const state = location.state as NotificationState;
  const [isInsightsOpen, setIsInsightsOpen] = useState<boolean>(false);
  const [selectedRisk, setSelectedRisk] = useState<any>(null);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [
    acknowledgeRiskModalOpen,
    setAcknowledgeRiskModalOpen,
  ] = useState<boolean>(false);

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };
  const handleDownload = async () => {
    const reportName = getReportName(selectedRisk.source_report);
    let reportType = '';
    if (
      selectedRisk?.vendor_type?.includes(
        'Administrative Services Only (ASO) Provider',
      ) &&
      selectedRisk?.vendor_type?.includes('Stop-Loss Insurance Provider')
    ) {
      reportType = 'asa-stoploss';
    }
    handleDownloadReport(
      reportName,
      // employerGroupStore.employerGroupResponseData.employer_group_name[0],
      'denali_water solutions_1733163850381',
      selectedRisk?.contract_id?._id,
      handleOpenSnackBar,
      employerGroupStore.employerGroupResponseData.eg_nid[0],
      selectedRisk?.compare_agreement_id?._id,
      reportType,
    );
  };
  const handleRiskClick = (risk: any) => {
    setSelectedRisk(risk);
    // setRiskDetailsWindowOpen(true);
  };
  const handleAction = (risk: any) => {
    setSelectedRisk(risk);
    setIsInsightsOpen(false);
    setAcknowledgeRiskModalOpen(true);
  };
  const handleAcknowledgeAction = async (risk: any) => {
    const data = {
      risk_id: risk?._id,
      status: 'Accepted',
    };
    await handleUpdateRisk(data);
  };

  const handleUpdateRisk = async (data: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'files') {
        continue;
      } // handle files separately below

      const value = data[key];

      if (Array.isArray(value)) {
        if (value.length && typeof value[0] === 'object') {
          // For arrays of objects like `activity`
          formData.append(key, JSON.stringify(value));
        } else {
          // For arrays of strings like `impact`, `owner`
          value.forEach((item: any, index: number) => {
            formData.append(`${key}[${index}]`, item);
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // In case any single object sneaks in
        formData.append(key, JSON.stringify(value));
      } else if (value !== '') {
        formData.append(key, value); // Only append non-empty values
      }
    }
    formData.append(
      'eg_nid',
      // 'crane_nxt_1742408999728',
      employerGroupStore.employerGroupResponseData.eg_nid[0],
    );
    formData.append(
      'employer',
      // employerGroupStore.employerGroupResponseData.employer_group_name[0],
      'denali_water solutions_1733163850381',
    );
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach((file: File) => {
        formData.append('files', file);
      });
    }
    await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.updateRisk,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    getNewAndUpcomingRisks();
    handleOpenSnackBar('Insights has been acknowledge', 'success', 6000);
    setIsInsightsOpen(false);
  };

  const handleNavigate = (
    contract: any,
    report: any,
    compare_agreement_id: any,
    handleOpenSnackBar: any,
  ) => {
    let path = '';
    switch (report) {
      case 'Gag Clause Compliance Check':
        path = GAG_CLAUSE_REPORT;
        break;
      case 'Provision Favorability Check':
        handleDownloadReport(
          'provisionMatrixReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          handleOpenSnackBar,
        );
        return;
      case 'Compensation Transparency Check':
        path = COMPENSATION_TRANSPARENCY_REPORT;
        break;
      case 'Inter-Contract Compliance Stop Loss and ASA':
      case 'Gap Analysis Check Plan Document and ASA':
      case 'Gap Analysis Check Plan Document and PBM':
        path = INTER_CONTRACT_REPORT;
        break;
      case 'Commercial Evaluation':
        handleDownloadReport(
          'feeEvaluationReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          handleOpenSnackBar,
        );
        return;
      default:
        return;
    }
    navigate(path, {
      state: {
        reportName: getReportName(report),
        document: `${contract?.health_care_partner_id?.health_care_partner} ${contract?.health_care_partner_id?.service_agreement_id?.service_agreement_name} Service Agreement`,
        healthcarePartner:
          contract?.health_care_partner_id?.health_care_partner,
        contract:
          contract?.health_care_partner_id?.service_agreement_id
            ?.service_agreement_name,
        contractId: contract._id,
        isContract: true,
        isReportsTab: true,
        compareId: compare_agreement_id?._id,
      },
    });
  };

  const enrichedNotifications = state.notifications.map((item) => {
    const { tagColor, tagIcons } = getTagProperties(item.tag);
    return {
      ...item,
      tagColor,
      tagIcons,
    };
  });

  // ðŸ” Search state
  const [searchText, setSearchText] = React.useState('');

  // ðŸ”„ Filter notifications based on search text
  const filteredNotifications = React.useMemo(() => {
    return enrichedNotifications.filter((item) =>
      item.notification.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [searchText, enrichedNotifications]);

  const message = experience;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const [newRiskTableloading, setNewRiskTableLoading] = useState<boolean>(
    false,
  );

  const [newRiskTableData, setNewRiskTableData] = useState<any>([]);

  const NEW_RISK_TABLE_COLUMNS: InsightsColumn[] = [
    {
      name: 'id',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Insight',
      cellStyles: cellStyles1,
      align: 'left',
      width: '400px',
    },
    {
      name: 'Priority',
      cellStyles: cellStyles1,
      align: 'left',
      width: '125px',
    },
    {
      name: '',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
    {
      name: 'Actions',
      cellStyles: cellStyles1,
      align: 'left',
      width: '150px',
    },
  ];

  const [newRiskTableTotalPages, setNewRiskTableTotalPages] = useState<number>(
    0,
  );

  const [newRiskTablePageNumber, setNewRiskTablePageNumber] = useState<number>(
    1,
  );

  const getRisks = async (
    status: any,
    pageNumber: number,
    is_current?: boolean,
  ) => {
    return await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.getRisk,
      {
        // eg_nid: 'crane_nxt_1742408999728',
        eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
        page: pageNumber,
        limit: 10,
        status: status,
        is_current,
      },
    );
  };

  const getNewAndUpcomingRisks = async () => {
    const isPlannedForCurrentQuarter = (plannedQuarter: string): boolean => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
      const currentQuarterLabel = `Q${currentQuarter} - ${currentYear}`;

      if (!plannedQuarter) {
        return false;
      }

      return (
        plannedQuarter === 'Current Quarter' ||
        plannedQuarter === currentQuarterLabel ||
        plannedQuarter === currentYear.toString()
      );
    };
    const risksData = await getRisks(
      ['New', 'Planned'],
      newRiskTablePageNumber,
      true,
    );
    const risks = risksData.data.data.risks;
    const newRiskItems = risks.filter((r: any) => r.risk_status === 'New');
    const upcomingRiskItems = risks.filter(
      (r: any) =>
        r.risk_status === 'Planned' &&
        isPlannedForCurrentQuarter(r.planned_quarter),
    );
    const formattedNewRisks = formatRiskTableInsights(
      mockAnalysis,
      // [...newRiskItems, ...upcomingRiskItems],
      handleRiskClick,
      handleAction,
      handleAcknowledgeAction,
    );
    setNewRiskTableData(formattedNewRisks);
    setNewRiskTableTotalPages(Math.ceil(risksData.data?.data?.totalPages));
  };

  useEffect(() => {
    const fetchRisks = async () => {
      setNewRiskTableLoading(true);
      await Promise.all([getNewAndUpcomingRisks()]);
      setNewRiskTableLoading(false);
    };
    fetchRisks();
  }, [newRiskTablePageNumber]);

  return (
    <Grid style={{ height: '100%', overflow: 'hidden', paddingBottom: '10px' }}>
      <Grid className={classes.pageHeader}>
        <NavigationArrow
          className={classes.navigationArrow}
          onClick={() =>
            navigate(EXPERICENCE_SCREEN, {
              state: {
                previousRoute: location.pathname,
              },
            })
          }
        />
        <PageTitleAndSubTitle
          title={message.TITLES.INSIGHTSTITLE}
          subTitle=""
          subTitleStyles={{ width: '90%' }}
          customButton={true}
          customButtonText={['Export', 'Customise Notifications']}
          customButtonVariant={['outlined']}
          customButtonStartIcon={[<Download />, <Settings />]}
          customButtonClick={[() => {}]}
          customButtonWidth={['116px', '250px']}
        />
      </Grid>
      <hr className={classes.hr} />
      <Grid className={classes.mainDiv}>
        <CardComponent
          title=""
          body={
            <>
              <Grid className={classes.buttonContainer}>
                <TextField
                  placeholder="Search"
                  height="44px"
                  width="200px"
                  endAdornment={<Search width="24px" height="24px" />}
                  value={searchText}
                  onChange={(e: any) => setSearchText(e.target.value)}
                />
                <Button
                  aria-describedby={id}
                  label="Add Filter"
                  startIcon={<Filter />}
                  onClick={() => {}}
                  height="44px"
                  width="150px"
                />
              </Grid>
              <Grid
                style={{
                  height: 'calc(100vh - 350px)',
                  overflow: 'auto',
                  padding: '20px 0',
                }}
              >
                <Grid className={classes.notificationContainer}>
                  {/* <NotificationTimeline data={filteredNotifications} /> */}
                </Grid>
              </Grid>
            </>
          }
        />
      </Grid>
      <BasicModal
        open={false}
        width="1000px"
        height="auto"
        handleClose={() => {}}
        title={'Insights'}
        isSaveButton={false}
        saveBtnText="Save"
        saveBtnAction={() => {}}
        isScrollable={true}
      >
        <Grid>
          {/* <InsightsPopup
          data={}
            children={
              <Grid>
                {newRiskTableloading ? (
                  <CircularLoader />
                ) : true ? (
                  <BasicTable
                    columns={NEW_RISK_TABLE_COLUMNS}
                    rowsData={newRiskTableData}
                    hideColumnIndex={0}
                    showPagination={true}
                    pageCount={newRiskTableTotalPages}
                    pageNumber={newRiskTablePageNumber}
                    handlePagination={(
                      event: ChangeEvent<unknown>,
                      page: number,
                    ) => {
                      setNewRiskTablePageNumber(page);
                    }}
                  />
                ) : (
                  <></>
                  // <NoComplianceAssurances
                  //   isImageOnTop={true}
                  //   title={messages.NO_NEW_RISK}
                  //   subTitle={messages.NO_NEW_RISK_SUB}
                  //   image={<EmptyAmico1 />}
                  //   buttonLabel={messages.ADD_NEW_RISK}
                  //   handleOnclick={() => {
                  //     setNewRiskModalOpen(true);
                  //   }}
                  //   startIcon={<Add />}
                  //   rootStyles={{
                  //     border: '0px',
                  //     background: '',
                  //     padding: '20px',
                  //     height: '350px',
                  //   }}
                  //   titleFont="18px"
                  //   subTitleFont="14px"
                  //   subTitleMargin="0px"
                  // />
                )}
              </Grid>
            }
          /> */}
        </Grid>
      </BasicModal>
      {acknowledgeRiskModalOpen && (
        <AcknowledgeRiskModal
          open={acknowledgeRiskModalOpen}
          setOpen={setAcknowledgeRiskModalOpen}
          handleOpenSnackBar={handleOpenSnackBar}
          handleSubmit={handleUpdateRisk}
          risk={selectedRisk}
          handleDownload={handleDownload}
          eg_nid={'crane_nxt_1742408999728'}
          handleNavigate={handleNavigate}
          // eg_nid={employerGroupStore.employerGroupResponseData.eg_nid[0]}
        />
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </Grid>
  );
});

export default AllInsigntsAndNotification;
